<template>
<div id="form-container" ref="formContainer" v-if="supervisorApplication != null">
    <div id="pgTitle" tabindex="-1"><h1>Update {{getSSSectionLabel}}</h1></div>

    <form-wizard :stepSize="stepSize"
                 :nextButtonText="buttons.next"
                 :backButtonText="buttons.back"
                 :finishButtonText="buttons.submit"
                 color="#003865"
                 :layout="layout"
                 @on-complete="onSubmit"
                 id="wizard"
                 @on-change="switchTabs"
    >
        <span slot="title" tabindex="-1"/>                
        
        <tab-content :title="getSSSectionLabel"
                     :before-change="()=>validateStep('spon')" :after-change="()=>scrollTo()">
            <SupervisorUpdate ref="spon" @on-validate="mergePartialModels" :application="supervisorApplication" :isSup="false" />
        </tab-content>

        <tab-content title="Signature"
                     :before-change="()=>validateStep('sig')" :after-change="()=>scrollTo()">
            <Signature ref="sig"/>
        </tab-content>               
        
    </form-wizard>
</div>

</template>

<script>
import axios from "axios"
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { commonOptions } from '@/mixins/commonOptions.js'
import { buttons, breadcrumbs } from '@/mixins/constants.js'
import SupervisorUpdate from '@/components/info-update/SupervisorUpdate.vue'
import Signature from '@/components/add-work-dates-wizard/Signature.vue'
import axiosRetry from 'axios-retry'


export default {
    components: {
        SupervisorUpdate,
        Signature,
    },
    mixins: [
        commonOptions,
        breadcrumbs,
        buttons
    ],
    data() {
        return {            
            stepSize: 'sm',
            layout: '',
            isSubmitted: false,
            shortCode: '',            
            supervisorApplication: null,
            isDisabled: false
        }
    },        
    created() {
        if (this.$route.params.id) {
            this.loadApplication(this.$route.params.id)
        }
    },
    methods: {
        buttons: function() {
            return buttons
        },
        breadcrumbs: function() {
            return breadcrumbs
        },
        onSubmit() {
            if (!this.isDisabled) {
                this.isDisabled = true
                delete this.supervisorApplication.applyMethod
                this.sendToServer()
            }
        },
        sendToServer() {
            axiosRetry(axios, { retries: 0 })
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/amend/establishment`, this.supervisorApplication)
                .then(response => {
                    this.isSubmitted = true
                    this.$router.push('/home')
                });
        },

        loadApplication(id) {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/${id}`)
                .then(response => {
                    this.$nextTick(() => {
                        this.supervisorApplication = response.data;
                        this.supervisorApplication.license.licenseType = response.data.license.licenseType.code;
                        this.supervisorApplication.mnSupervisor.forEach(sup => {
                            sup.establishment.establishmentHours.forEach(hrs => {
                                if (hrs.days.some(d => d.code != undefined)) {
                                    hrs.days = hrs.days.map(d => d.code)
                                }
                            })
                        })
                        this.supervisorApplication.prevMnSupervisor.forEach(sup => {
                            sup.establishment.establishmentHours.forEach(hrs => {
                                if (hrs.days.some(d => d.code != undefined)) {
                                    hrs.days = hrs.days.map(d => d.code)
                                }
                            })
                        })
                    });
                })
            },

        loadProfile() {
            axiosRetry(axios, { retries: 3,
                retryDelay: axiosRetry.exponentialDelay  })

            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile`)
                .then(response => { 
                    this.profile = response.data
            })
        },
        
        validateStep(name) {
            var refToValidate = this.$refs[name]
            return refToValidate.validate()
        },

        mergeCheck(model) {
            this.isCheck = model['isCheck']
        },

        mergePartialModels(model, isValid) {
            if(isValid){
                // merging each step model into the final model
                this.supervisorApplication = Object.assign({}, this.supervisorApplication, model)
                if (this.supervisorApplication.opts) {
                    delete this.supervisorApplication.opts
                }                
            }
        },        

        scrollTo() {
            let elem = document.getElementById("wizard")
            elem.scrollIntoView()
        },

        focus(e) {
            let elem = document.getElementsByClassName("card-header")[e+1]
            elem.focus()
        },

        switchTabs(prevIdx, nextIdx) {
            var title = 'Welcome'
            switch (nextIdx) {                
                case 0:
                    title = 'Supervisor/Sponsor & Establishment'
                    break;
                case 1:
                    title = 'Signature'
                    break;
                default:
                    title = 'Supervisor/Sponsor & Establishment Information'
            }           
            document.getElementById('pgTitle').focus()
        },
        
        removeTabFocus() {
            this.$nextTick(function () {
                var steps = document.querySelectorAll("div[role='tab']")
                steps.forEach(step => {
                    step.setAttribute("tabindex", "-1")
                })

                var steps2 = document.querySelectorAll(".wizard-nav-pills>li>a");
                steps2.forEach(step => {
                    step.setAttribute("tabindex", "-1")
                    step.setAttribute("aria-disabled","true")
                })
            })
        },                
    },
    updated: function() {
        this.removeTabFocus()
    },
    mounted() {
        this.removeTabFocus()
    },
    computed: {
        getSSSectionLabel() {
            if (this.supervisorApplication.subCategory == 'GUEST') {
                return "Sponsor"
            } else {
                return "Supervisor"
            }
        },
    },
}
</script>

<style>
.card {
    margin-bottom: 18px;
}
.card-header {
    font-weight: 700;
}
</style>
